import type React from "react";
import {observer} from "mobx-react-lite";
import {DrawerMenuItem} from "../drawer/DrawerMenuItem.tsx";
import {List} from "@mui/material";
import Divider from "@mui/material/Divider";
import {DrawerMainLogo} from "../branding/DrawerMainLogo.tsx";
import {useStores} from "../../../stores";

export const MainMenu: React.FC = observer(() => {
    const {p, rootAppStore} = useStores();
    const showSit = p.showCard("sit");
    const showChat = p.showCard("chat");
    return (
        <>
            <DrawerMainLogo collapsed={!rootAppStore.isDrawerOpen}/>
            <List
                className="menuList"
                sx={{
                    "&.MuiList-root": {padding: 0},
                    ...(!rootAppStore.isDrawerOpen && {
                        "& .MuiListItemIcon-root": {
                            marginRight:'0px !important',
                        },
                    }),
                }}
            >
                <DrawerMenuItem card="__home__"/>
                <DrawerMenuItem card="daily-briefing"/>
                <Divider component="li"/>

                {(showSit ||
                    !!p.p.enableDataIngestion ||
                    !!p.p.enableTaxonomyIngestion) && (
                    <>
                        {showSit && <DrawerMenuItem card="sit"/>}
                        {p.p.enableDataIngestion && (
                            <DrawerMenuItem card="data-ingestion"/>
                        )}
                        {p.p.enableTaxonomyIngestion && (
                            <DrawerMenuItem card="taxonomy-ingestion"/>
                        )}
                        <Divider component="li"/>
                    </>
                )}

                {showChat && (
                    <>
                        <DrawerMenuItem card="chat"/>
                        <Divider component="li"/>
                    </>
                )}

                <DrawerMenuItem card="taxonomy-suggester"/>
                <DrawerMenuItem card="taxonomy-builder"/>
                <DrawerMenuItem card="categorization-review"/>
                <DrawerMenuItem card="contract-linkage"/>
                <DrawerMenuItem card="supplier-normalization"/>
                <DrawerMenuItem card="contract-insights"/>
                <DrawerMenuItem card="golden-record"/>
                <Divider component="li"/>
                <DrawerMenuItem card="adv-dashboard"/>
                <DrawerMenuItem card="supplier-360"/>
                <DrawerMenuItem card="opportunity-intelligence"/>
                <DrawerMenuItem card="contract-coverage-intelligence"/>
                <DrawerMenuItem card="payment-terms"/>
                <DrawerMenuItem card="koi-key-data-facts"/>
                <DrawerMenuItem card="koi-spend-concentration"/>
                <DrawerMenuItem card="koi-ppv"/>
            </List>
        </>
    );
});
